import { useState } from 'react';

import { useNavigate } from 'react-router-dom';
// @mui
import { Link, Stack, IconButton, InputAdornment, TextField, Alert } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import axios from 'axios';
// components
import Iconify from '../../../components/iconify';
import baseURL from '../../../baseurl';

// ----------------------------------------------------------------------

export default function LoginForm() {
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

const handleforget = ()=>{
  navigate('/forgetpassword');
}

  const handleClick = async () => {
    setError('');
    setLoading(true);
    try {
      const { data } = await axios.post(
        `${baseURL}/admin/login`,
        { email, password },
        { headers: { 'Content-Type': 'application/json' } }
      );

      if (data?.success) {
        const admin = data.admin || {};
        localStorage.setItem('token', JSON.stringify(data.token));
        localStorage.setItem('fullName', JSON.stringify(admin.fullName || ''));
        localStorage.setItem('id', JSON.stringify(admin.id || ''));
        localStorage.setItem('email', JSON.stringify(admin.email || email));
        navigate('/dashboard/quiz', { replace: true });
        return;
      }

      setError(data?.message || 'Login failed. Please check your email and password.');
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Stack spacing={3}>
        <TextField
          name="email"
          label="Email address"
          value={email}
          onChange={(evt) => {
            setEmail(evt.target.value); }}/>

        <TextField
          name="password"
          label="Password"
          value={password}
          onChange={(evt) => {
            setPassword(evt.target.value); }}
          type={showPassword ? 'text' : 'password'}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                  <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Stack>

      <Stack direction="row" alignItems="center" alignSelf="end"  justifyContent="space-between" sx={{ my: 2 }}>
        {/* <Checkbox name="remember" label="Remember me" /> */}
        <Link  variant="subtitle2" underline="hover" onClick={handleforget}>
          Forgot password?
        </Link>
      </Stack>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <LoadingButton fullWidth size="large" type="submit" variant="contained" loading={loading} onClick={handleClick}>
        Login
      </LoadingButton>
    </>
  );
}
